import React, { lazy, Suspense } from "react";

const UFC_DC_RF_V1 = lazy(
  () => import('./Components/Pages/Splits/UFC_DC_RF_V1')
);

const OD_UFL_4 = lazy(
  () => import('./Components/Pages/Splits/OD_UFL_4')
);

const AppSplitList = (props) => {
  const SplitListMap = {
    UFC_DC_RF_V1 : UFC_DC_RF_V1,
    OD_UFL_4: OD_UFL_4
  };
  const SplitComponent = SplitListMap[props.splitName];
  return (
    <Suspense fallback={<div>Loading...</div>}>
      {SplitComponent && <SplitComponent />}
    </Suspense>
  );
};

export default AppSplitList;
